import {
    GET_MATERIAL_RETURN_ORDER_REQUEST,
    GET_MATERIAL_RETURN_ORDER_SUCCESS,
    GET_MATERIAL_RETURN_ORDER_FAILURE,
} from "./materialReturnOrderTypes";

const initialState = {
  loading: false,
  materialReturnOrders: [],
  error: "",
};

const getMaterialReturnOrderReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case GET_MATERIAL_RETURN_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_MATERIAL_RETURN_ORDER_SUCCESS:
      return {
        loading: false,
        materialReturnOrders: action.payload,
        error: "",
      };
    case GET_MATERIAL_RETURN_ORDER_FAILURE:
      return {
        loading: false,
        materialReturnOrders: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getMaterialReturnOrderReducer };
